export default "__VITE_ASSET__209364af__"